import React, { Component } from "react";
import { compose } from "redux";
import classNames from "classnames";
import { routerActions } from "connected-react-router";
import { connect } from "react-redux";
import { string, bool, func, arrayOf, number, shape, oneOfType, object } from "prop-types";

import * as fileMiddleware from "middleware/file";
import { actions as fileActions } from "reducers/files";
import { actions as formActions } from "reducers/form";
import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import { actions, selectors as multilineFileSelectors } from "reducers/formFields/multilineFile";
import { actions as notificationActions } from "reducers/notification";

import FileUploader from "pages/_components/FileUploader";
import DetailBox from "pages/_components/detailBox/DetailBox";
import I18n from "pages/_components/I18n";
import FileActions from "pages/forms/_components/_fields/_commons/FileActions";
import withFocus from "pages/_components/withFocus";
import LinesInfo from "./LinesInfo";

class FilePayment extends Component {
    static propTypes = {
        idField: string.isRequired,
        idForm: string.isRequired,
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
        setValue: func.isRequired,
        processedFileData: shape({
            fileIdentifier: string.isRequired,
            hasFile: bool.isRequired,
            validLines: number,
            invalidLines: number,
            totalAmount: shape({
                currency: string.isRequired,
                quantity: number.isRequired,
            }).isRequired,
        }).isRequired,
        fieldList: arrayOf(shape({})),
        idRelatedFile: string,
        idFile: string,
        value: arrayOf(shape({})),
        maxFileSizeMB: number.isRequired,
        acceptedFileTypes: arrayOf(string).isRequired,
        isFocused: bool,
        toggleIsFocused: func,
        typePayment: string,
        notificationScope: string,
        successNotificationMessage: string,
        warningNotificationMessage: string,
        errorNotificationMessage: string,
        linesInfoMessage: string,
        field: shape({
            onBlur: func,
            onChange: func,
            name: string,
            value: oneOfType([number, string, arrayOf(shape({}))]),
        }).isRequired,
        form: shape({
            errors: shape({}),
            touched: shape({}),
        }).isRequired,
        fileNameRegex: shape({}),
        description: oneOfType([object, string]),
        idActivity: string,
        allowFileTypeValidation: bool,
        fileErrorMessage: string,
        idAccount: string,
    };

    static defaultProps = {
        fieldList: [],
        idRelatedFile: null,
        idFile: null,
        value: null,
        isFocused: false,
        toggleIsFocused: null,
        typePayment: "",
        notificationScope: "form",
        successNotificationMessage: "",
        warningNotificationMessage: "",
        errorNotificationMessage: "",
        linesInfoMessage: "",
        fileNameRegex: null,
        description: "",
        idActivity: "core.forms.send",
        allowFileTypeValidation: true,
        fileErrorMessage: "",
        idAccount: "",
    };

    componentDidMount() {
        const { dispatch, processedFileData } = this.props;

        if (processedFileData.hasFile) {
            //   setValue([processedFileData.filesMetadata]);
        }
        dispatch(transactionLinesActions.onPaymentMethodChange());
    }

    componentDidUpdate(prevProps) {
        const { processedFileData, dispatch, notificationScope, hasEnoughBalance, trxLimitExceeded, setTrxLimitExceeded} = this.props;
        if (processedFileData && prevProps.processedFileData !== processedFileData) {
            const { filesMetadata, message, invalidLines } = processedFileData;

            if (filesMetadata) {
                if (!invalidLines) {
                    // Muestro el snackbar de archivo cargado solo si tiene suficiente saldo y puede continuar, ya que si no tiene se solapa con el snackbar de saldo insuficiente
                    if (hasEnoughBalance && !trxLimitExceeded)
                        dispatch(notificationActions.showNotification(`${message}`, "success", [notificationScope]));
                } else {
                    dispatch(notificationActions.showNotification(`${message}`, "warning", [notificationScope]));
                }

            }
        }
    }

    handleFileProcess = (data) => {
        const { dispatch, form, field } = this.props;
        form.setFieldTouched(field.name, true);
        dispatch(actions.onFileProcess(data));
    };

    handleError = (data) => {
        const { dispatch, notificationScope, form, field } = this.props;
        let { errorMessage } = data;

        form.setFieldTouched(field.name, true);
        errorMessage = errorMessage.endsWith(".") ? errorMessage.substring(0, errorMessage.length - 1) : errorMessage;
        dispatch(notificationActions.showNotification(`${errorMessage}.`, "error", [notificationScope]));
    };

    handleClick = () => {
        const { dispatch, form, fieldList, idFile, idForm, idRelatedFile, idField } = this.props;
        const { idField: selectorId, optionList } = fieldList.find(
            (field) => field.type === "selector" && field.defaultValue === "file",
        );

        if (idRelatedFile !== undefined) {
            fileMiddleware.deleteFile(Number(idRelatedFile));
        }
        dispatch(transactionLinesActions.setIsEditingPayment(false));
        dispatch(fileActions.getFileContentsRequest(idFile, true));
        dispatch(routerActions.push(`/form/${idForm}/manual`));
        dispatch(
            formActions.setData({
                ...form.values,
                [selectorId]: [optionList[1].id],
                [idField]: [],
            }),
        );
    };

    handleBlur = (event) => {
        const { field, toggleIsFocused } = this.props;

        field.onBlur(event);
        toggleIsFocused();
    };

    renderDetail = ({ downloadFile }) => {
        const { processedFileData, linesInfoMessage } = this.props;
        const { invalidLines, invalidHeader, invalidFile, validLines, totalAmount } = processedFileData;

        if (invalidLines === null) {
            return null;
        }

        if (invalidHeader) {
            return (
                <div className="alert alert-warning" role="alert">
                    <I18n id="forms.inputFile.massivePayments.invalid.header" invalidLines={invalidLines} />
                </div>
            );
        }

        if (totalAmount?.currency === "01") {
            totalAmount.currency = "ARS";
        }

        return (
            <DetailBox>
                <LinesInfo
                    validLines={validLines}
                    invalidLines={invalidLines}
                    totalAmount={totalAmount}
                    downloadFile={downloadFile}
                    invalidFile={invalidFile}
                    linesInfoMessage={linesInfoMessage}
                />
            </DetailBox>
        );
    };

    // hasError = () => {
    //     const {
    //         processedFileData,
    //         form: { touched },
    //     } = this.props;
    //     const { invalidHeader, invalidFile, hasFile } = processedFileData;
    //     const wasTouched = !!Object.entries(touched).find((entrie) => entrie[0].includes("filepond--browser"))?.[1];
    //     return (invalidHeader || invalidFile || !hasFile) && wasTouched;
    // };

    render() {
        const {
            acceptedFileTypes,
            dispatch,
            idForm,
            idField,
            isFocused,
            maxFileSizeMB,
            processedFileData,
            setValue,
            toggleIsFocused,
            value,
            successNotificationMessage,
            warningNotificationMessage,
            errorNotificationMessage,
            notificationScope,
            fileNameRegex,
            allowFileTypeValidation,
            description,
            idActivity,
            fileErrorMessage,
            idAccount,
        } = this.props;
        const { invalidLines } = processedFileData;

        return (
            <FileActions
                {...this.props}
                renderPreview={this.renderDetail}
                render={({ onRemoveFile, onAddFile, downloadFile }) => (
                    <div
                        onFocus={toggleIsFocused}
                        onBlur={this.handleBlur}
                        className={classNames("form-group", {
                            // "has-error": this.hasError(),
                            "has-focus": isFocused,
                            "invalid-lines": invalidLines > 0,
                        })}>
                        <FileUploader
                            name={idField}
                            idActivity={idActivity}
                            idForm={idForm}
                            idFormField={idField}
                            description={description}
                            files={value}
                            allowMultiple={false}
                            maxFileSize={`${maxFileSizeMB}mb`}
                            maxTotalFileSize={`${maxFileSizeMB}mb`}
                            maxFiles={1}
                            allowImagePreview
                            allowFileSizeValidation
                            minFileSize="1B"
                            acceptedFileTypes={acceptedFileTypes}
                            onFileProcess={this.handleFileProcess}
                            onError={this.handleError}
                            onAddFile={onAddFile}
                            onRemoveFile={(file) => {
                                onRemoveFile(file);
                                dispatch(actions.onFileRemoved());
                            }}
                            setValue={setValue}
                            successNotificationMessage={successNotificationMessage}
                            warningNotificationMessage={warningNotificationMessage}
                            errorNotificationMessage={errorNotificationMessage}
                            notificationScope={notificationScope}
                            fileNameRegex={fileNameRegex}
                            allowFileTypeValidation={allowFileTypeValidation}
                            fileErrorMessage={fileErrorMessage}
                            idAccount={idAccount}
                        />
                        {this.renderDetail({ downloadFile })}
                    </div>
                )}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    idFile: multilineFileSelectors.getProcessedFileData(state).idFile,
});

export default compose(connect(mapStateToProps), withFocus)(FilePayment);
